/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hierarchy_medium'
export default icon
